import { createSelector } from 'reselect';
import { PROGRESS_FLAG_SELL_WITHHOLDING_WARNED } from 'src/settings/settings';
import { ApplicationState } from '../types';

export const getProgressState = ({ progress }: ApplicationState) => progress;

export const getProgressCurrentStep = createSelector(
  [getProgressState],
  ({ currentStep }) => currentStep
);

export const getSellWithholdingWarned = createSelector(
  [(_, progressFlag?: string) => progressFlag, getProgressState],
  (progressFlag = PROGRESS_FLAG_SELL_WITHHOLDING_WARNED, { progressFlags }) => {
    return !!progressFlags?.[progressFlag];
  }
);
